import { registerComponent } from '../app'
import $ from 'jquery'

const Tabs = (scope, el) => {
	const props = {
		activeClass: 'active'
	}

	const els = {
		$navItems: $(el).find('[data-nav-item]'),
		$tabs: $(el).find('[data-tab]')
	}

	els.$navItems.on('click', function() {
		els.$tabs.removeClass(props.activeClass)
		els.$navItems.removeClass(props.activeClass)
		els.$tabs[this.getAttribute('data-nav-item')].classList.add(props.activeClass)
		els.$navItems[this.getAttribute('data-nav-item')].classList.add(props.activeClass)
	})
}

registerComponent('tabs', Tabs)
